import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { fetchGeneralReport } from "../../../store/slices/reportSlice";
import GeneralReportsList from "./GeneralReportsList";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import MainLayout from "../../../components/layout/MainLayout";

const GeneralReports = () => {
  const dispatch = useDispatch();
  const { generalReport, isLoading } = useSelector((state) => state.reports);
  
  const [showFilters, setShowFilters] = useState(false);
  const [tempFilters, setTempFilters] = useState({
    startDate: "",
    endDate: "",
    source: "",
    gender: "",
    diagnosis: ""
  });

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: '31px',
      height: '31px',
      fontSize: '0.8125rem',
      borderRadius: '0.375rem',
      borderColor: '#d9dee3',
      '&:hover': {
        borderColor: '#d9dee3'
      }
    }),
    valueContainer: (base) => ({
      ...base,
      padding: '0 8px',
      height: '31px',
    }),
    input: (base) => ({
      ...base,
      margin: '0',
      padding: '0',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: '31px',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '2px',
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: '2px',
    }),
    menu: (base) => ({
      ...base,
      fontSize: '0.8125rem',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#666ee8' : state.isFocused ? '#f5f5f9' : 'white',
      color: state.isSelected ? 'white' : '#566a7f',
      cursor: 'pointer',
    })
  };

  const sourceOptions = [
    { value: "", label: "All Sources" },
    { value: "Advertisement", label: "Advertisement" },
    { value: "Facebook", label: "Facebook" },
    { value: "Hospital Referral", label: "Hospital Referral" },
    { value: "Referred by: Medical Practitioner", label: "Referred by Medical Practitioner" },
    { value: "Referred by: Psychiatrist", label: "Referred by Psychiatrist" },
    { value: "Referred by: Psychologist", label: "Referred by Psychologist" },
    { value: "Seminar/Event", label: "Seminar/Event" },
    { value: "Social Media of TRH", label: "Social Media of TRH" },
    { value: "Saw the Signboard", label: "Saw the Signboard" },
    { value: "TV", label: "TV" },
    { value: "Walk-in", label: "Walk-in" },
    { value: "Website", label: "Website" },
    { value: "Word of Mouth", label: "Word of Mouth" },
    { value: "Other", label: "Other" },
  ];

  const genderOptions = [
    { value: "", label: "All Genders" },
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "other", label: "Other" },
  ];
  const [activeFilters, setActiveFilters] = useState({
    startDate: "",
    endDate: "",
    source: "",
    gender: "",
    diagnosis: ""
  });

  useEffect(() => {
    dispatch(fetchGeneralReport(activeFilters));
  }, [dispatch, activeFilters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setTempFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    setActiveFilters({ ...tempFilters });
  };

  const handleClear = () => {
    const cleared = {
      startDate: "",
      endDate: "",
      source: "",
      gender: "",
      diagnosis: ""
    };
    setTempFilters(cleared);
    setActiveFilters(cleared);
  };

  return (
    <MainLayout>
      <Breadcrumbs />
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="mb-0">General Reports</h4>
          <div>
            <button
              className={`btn btn-sm ${showFilters ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setShowFilters(!showFilters)}
            >
              <i className="ri-filter-line me-1"></i> {showFilters ? 'Hide Filters' : 'Filters'}
            </button>
          </div>
        </div>

        {/* Filters Accordion */}
        <div className={`collapse ${showFilters ? 'show' : ''}`}>
          <div className="px-4 py-3">
            <div className="card shadow-sm border">
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label small fw-bold">Start Date</label>
                    <input type="date" name="startDate" className="form-control form-control-sm" value={tempFilters.startDate} onChange={handleFilterChange} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small fw-bold">End Date</label>
                    <input type="date" name="endDate" className="form-control form-control-sm" value={tempFilters.endDate} onChange={handleFilterChange} />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label small fw-bold">Source</label>
                    <Select
                      options={sourceOptions}
                      styles={selectStyles}
                      value={sourceOptions.find(opt => opt.value === tempFilters.source)}
                      onChange={(opt) => setTempFilters(prev => ({ ...prev, source: opt.value }))}
                      placeholder="Select Source"
                      isSearchable
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label small fw-bold">Gender</label>
                    <Select
                      options={genderOptions}
                      styles={selectStyles}
                      value={genderOptions.find(opt => opt.value === tempFilters.gender)}
                      onChange={(opt) => setTempFilters(prev => ({ ...prev, gender: opt.value }))}
                      placeholder="Select Gender"
                      isSearchable
                    />
                  </div>
                  <div className="col-md-2 d-flex align-items-end gap-2">
                    <button className="btn btn-sm btn-label-secondary w-50" onClick={handleClear}>Clear</button>
                    <button className="btn btn-sm btn-primary w-50" onClick={handleSubmit}>Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <GeneralReportsList data={generalReport} filters={activeFilters} isLoading={isLoading} />
      </div>
    </MainLayout>
  );
};

export default GeneralReports;
